import styled from 'styled-components';

export const Description = styled.h2`
  font-size: 0.9em;
  text-align: center;
  margin: 1em;
  color: #fff;
  overflow-wrap: break-word;
     @media (min-width: 768px) {
          font-size: 1.5em;
    }
`;